import {Loadable} from 'app/components/general/lazyLoader';
import {DetailLoadingPage} from 'app/general/loading/DetailLoadingPage';
import {cats, withShortcuts} from 'app/general/shortcuts/withShortcuts';
import {gt} from 'app/utils/i18n';

import type {WithShortcutOwnProps} from './ProcedureEditPage';
import type {SweetError} from 'app/utils/errors';

/* eslint-enable no-unused-vars */
const BaseLoadableProcedureEditPage = Loadable<
  SweetError,
  WithShortcutOwnProps
>({
  loader: () =>
    import(
      /* webpackChunkName: "edit-pages" */
      './ProcedureEditPage'
    ),
  LoadingComponent: DetailLoadingPage,
});
export const withProcedureEditPageShortcuts =
  withShortcuts<WithShortcutOwnProps>([
    {
      key: 's',
      name: () => gt('Add Step'),
      category: cats.editPage,
    },
    {
      key: 'esc',
      name: () => gt('Save and close current step'),
      category: cats.editPage,
    },
  ]);
export const LoadableProcedureEditPage = withProcedureEditPageShortcuts(
  BaseLoadableProcedureEditPage
);
